import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "authModal",
  tabindex: "-1",
  "aria-labelledby": "authModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-body p-5 pt-0" }
const _hoisted_4 = { class: "d-flex justify-content-center mb-4" }
const _hoisted_5 = {
  class: "nav nav-pills",
  role: "tablist"
}
const _hoisted_6 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_7 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_8 = { class: "tab-content" }
const _hoisted_9 = {
  key: 0,
  class: "tab-pane fade show active"
}
const _hoisted_10 = {
  key: 1,
  class: "tab-pane fade show active"
}
const _hoisted_11 = {
  key: 2,
  class: "tab-pane fade show active"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Login = _resolveComponent("Login")!
  const _component_Register = _resolveComponent("Register")!
  const _component_ForgotPassword = _resolveComponent("ForgotPassword")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-dialog modal-dialog-centered", { 'modal-lg': _ctx.activeTab !== 'forgot', 'modal-md': _ctx.activeTab === 'forgot' }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "modal-header border-0" }, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ul", _hoisted_5, [
              _createElementVNode("li", _hoisted_6, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'login' }]),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchTab('login'))),
                  type: "button"
                }, " Accedi ", 2)
              ]),
              _createElementVNode("li", _hoisted_7, [
                _createElementVNode("button", {
                  class: _normalizeClass(["nav-link", { active: _ctx.activeTab === 'register' }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchTab('register'))),
                  type: "button"
                }, " Registrati ", 2)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.activeTab === 'login')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_Login, {
                    onLoginSuccess: _ctx.handleAuthSuccess,
                    onSwitchToRegister: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchTab('register'))),
                    onSwitchToForgot: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchTab('forgot')))
                  }, null, 8, ["onLoginSuccess"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.activeTab === 'register')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_Register, {
                    onRegisterSuccess: _ctx.handleAuthSuccess,
                    onSwitchToLogin: _cache[4] || (_cache[4] = ($event: any) => (_ctx.switchTab('login')))
                  }, null, 8, ["onRegisterSuccess"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.activeTab === 'forgot')
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_ForgotPassword, {
                    isModal: true,
                    onForgotSuccess: _ctx.handleForgotSuccess,
                    onSwitchToLogin: _cache[5] || (_cache[5] = ($event: any) => (_ctx.switchTab('login')))
                  }, null, 8, ["onForgotSuccess"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 2)
  ]))
}